<div id="content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>{{ page_title }}</h1>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="bisual-table">
          <form class="card paginator" [formGroup]="filterForm">
            <mat-paginator
              [length]="length"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [pageIndex]="pageIndex"
              (page)="changePage($event)"
              style="margin-right: auto"
            ></mat-paginator>
            @if (is_rrhh_or_admin()) {
              <mat-form-field style="margin-right: 10px; min-width: 150px">
                <mat-label>Responsable</mat-label>
                <mat-select formControlName="responsible_user_id">
                  <mat-option [value]="''">Todas</mat-option>
                  <mat-option [value]="current_user_id">Las que gestiono yo</mat-option>
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field style="margin-right: 10px; min-width: 150px">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="status">
                <mat-option [value]="''">Todos</mat-option>
                <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.PENDING">Pendiente</mat-option>
                <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED">Aceptada</mat-option>
                <mat-option [value]="EmployeeRequestResponsibleForAnswerStatusEnum.REJECTED">Rechazada</mat-option>
              </mat-select>
            </mat-form-field>
          </form>

          <div class="bisual-table-container">
            <table mat-table [dataSource]="data_source">
              <ng-container matColumnDef="driver">
                <th mat-header-cell *matHeaderCellDef>Conductor</th>
                <td mat-cell *matCellDef="let element">{{ element.driver }}</td>
              </ng-container>

              <ng-container matColumnDef="trip_date">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let element">{{ element.trip_date }}</td>
              </ng-container>

              <ng-container matColumnDef="route">
                <th mat-header-cell *matHeaderCellDef>Ruta</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.origin) {
                    <button
                      type="button"
                      class="route-location-button"
                      (click)="openLocationDialog(element.origin)"
                      matTooltip="Ver origen en el mapa"
                    >
                      <mat-icon>place</mat-icon>
                      <span>{{ element.origin.name }}</span>
                    </button>
                  } @else {
                    —
                  }

                  @if (element.origin && element.destination) {
                    <span class="route-separator">→</span>
                  }

                  @if (element.destination) {
                    <button
                      type="button"
                      class="route-location-button"
                      (click)="openLocationDialog(element.destination)"
                      matTooltip="Ver destino en el mapa"
                    >
                      <mat-icon>flag</mat-icon>
                      <span>{{ element.destination.name }}</span>
                    </button>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="trip_distance">
                <th mat-header-cell *matHeaderCellDef>Kilómetros</th>
                <td mat-cell *matCellDef="let element">{{ element.trip_distance }}</td>
              </ng-container>

              <ng-container matColumnDef="company_product">
                <th mat-header-cell *matHeaderCellDef>Producto</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.company_product; as company_product) {
                    <a
                      class="company-product-link"
                      [routerLink]="['/employees', 'development', 'company-products', company_product.id, 'resume']"
                    >
                      @if (company_product.logo_url) {
                        <img class="company-product-logo" [src]="company_product.logo_url" [alt]="company_product.title" />
                      } @else {
                        <span class="company-product-logo company-product-logo-placeholder">{{
                          company_product.title.charAt(0).toUpperCase()
                        }}</span>
                      }
                      <span class="company-product-name">{{ company_product.title }}</span>
                    </a>
                  } @else {
                    —
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">
                  <span [class]="'status-badge status-' + element.request.status">
                    {{ element.status_label }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <div class="actions-cell">
                    <button mat-icon-button (click)="openApprovalStatusDialog(element.request)" matTooltip="Estado de aprobación">
                      <mat-icon>info</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      (click)="openResolutionDialog(element.request)"
                      [matTooltip]="
                        element.request.status === EmployeeRequestResponsibleForAnswerStatusEnum.PENDING
                          ? 'Resolver solicitud'
                          : 'Ver resolución'
                      "
                    >
                      @if (element.request.status === EmployeeRequestResponsibleForAnswerStatusEnum.PENDING) {
                        <mat-icon>assignment</mat-icon>
                      } @else if (element.request.status === EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED) {
                        <mat-icon>assignment_turned_in</mat-icon>
                      } @else if (element.request.status === EmployeeRequestResponsibleForAnswerStatusEnum.REJECTED) {
                        <mat-icon>assignment_late</mat-icon>
                      }
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
